// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1oE-C","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2MwRv","obliqueLine":"membershipbadge_obliqueLine__SDQIs"};